<template>
  <div>
    <a-breadcrumb>
      <a-breadcrumb-item>文档</a-breadcrumb-item>
      <a-breadcrumb-item><router-link to="/document/fileCollection">Portfolio文件收集</router-link></a-breadcrumb-item>
      <a-breadcrumb-item>项目人员维护</a-breadcrumb-item>
    </a-breadcrumb>

    <!-- edit-alert -->
    <a-modal v-model="isEdit" title="编辑项目人员关系" @ok="onSubmit" @cancel="onCancel">
      <div class="edit-alert">
        <p><span class="edit-alert-item-info">项目名称</span>{{ companyNow.companyName }}</p>
        <p><span class="edit-alert-item-info">Deal Leader</span>{{ companyNow.dealLeader ? companyNow.dealLeader.nickname : '' }}</p>
        <p>
          <span class="edit-alert-item-info">Deal Member</span>
          <span class="edit-alert-dm" v-for="i in companyNow.dealMembers" :key="i.id">{{ i ? i.nickname : '' }}</span>
        </p>
        <a-divider />

        <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item label="文件催收人" prop="urge">
            <div class="edit-alert-item-input">
              <select-member
                :userlist="userList"
                :parentIndex="0"
                :multiChoose="true"
                :canEdit="true"
                :abridged="5"
                :canExpand="true"
                @delChosenUser="delUserIds"
                @chose="choseUserIds"
              ></select-member>
              <a-input style="display:none" v-model="form.urge" />
            </div>
          </a-form-model-item>
          <a-form-model-item label="公司对接人" prop="editName">
            <a-input v-model="form.editName" />
          </a-form-model-item>
          <a-form-model-item label="对接人电话" prop="editPhone">
            <a-input v-model="form.editPhone" />
          </a-form-model-item>
          <a-form-model-item label="对接人邮箱" prop="editEmail">
            <a-input v-model="form.editEmail" />
          </a-form-model-item>
          <!-- // TODO 加抄送 -->
          <a-form-model-item label="抄送人邮箱" prop="copyToEmail" class="copy-to-email">
            <a-input v-model="form.copyToEmail" @pressEnter="addCopyToEmail" />
            <a-button style="margin: 4px 0 0 10px;position: absolute" @click="addCopyToEmail">添加</a-button>
          </a-form-model-item>
          <a-row style="margin-top: -6px">
            <a-col :span="18" :offset="6">
              <a-tag style="margin-bottom: 8px" v-for="(i, index) in copyToEmailList" closable @close="deleteCopyToEmail(index)" :key="i">
                {{ i }}
              </a-tag>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
    </a-modal>
    <!-- edit-alert end -->

    <div class="table-layer">
      <!-- searchbar -->
      <div class="search-bar">
        <a-input-search placeholder="按项目名搜索" style="width: 300px" @search="onSearch" v-model="keyword" />
      </div>
      <!-- searchbar end -->
      <!-- table -->
      <a-table :columns="columns" :data-source="data" :pagination="false" :rowKey="_ => _.companyId">
        <span slot="action" slot-scope="text">
          <a-button type="primary" @click="showModal(text)">编辑</a-button>
        </span>
      </a-table>
      <!-- table end -->
      <!-- 分页 -->
      <div class="pagination-buttom">
        <a-pagination v-if="total > 10" v-model="current" :total="total" :page-size="pageSize" @change="onChange" :show-total="total => `共有 ${total} 条数据`">
        </a-pagination>
      </div>
      <!-- 分页end -->
    </div>
  </div>
</template>
<script>
import selectMember from '@/components/project/selectMember.vue';
import { editPortfolioMember, getPortfolioMember } from '@/api/document';
import { FormModel } from 'ant-design-vue';

const columns = [
  {
    title: '项目名称',
    dataIndex: 'companyName',
    key: 'companyName'
  },
  {
    title: '文件催收人',
    dataIndex: 'urgePeople',
    customRender: (value, row, index) => {
      const obj = {
        children: value && value.length > 0 && value[0] ? value.map(_ => _.nickname).join(', ') : '',
        attrs: {}
      };
      return obj;
    }
  },
  {
    title: '公司对接人',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '公司对接人电话',
    dataIndex: 'phone',
    key: 'phone'
  },
  {
    title: '公司对接人邮箱',
    dataIndex: 'email',
    key: 'email'
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' }
  }
];

const data = [];

export default {
  components: { selectMember },
  data() {
    const validatorPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入对接人电话!'));
      } else {
        if (!/^[0-9-]{1,}$/.test(value)) {
          callback(new Error('电话格式不正确!'));
        } else {
          callback();
        }
      }
    };
    const validatorEmail = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入对接人邮箱!'));
      } else {
        if (!/^[\.a-zA-Z0-9_-]+@[\.a-zA-Z0-9_-]+(\.[\.a-zA-Z0-9_-]+)+$/.test(value.trim())) {
          callback(new Error('邮箱格式不正确!'));
        } else {
          callback();
        }
      }
    };
    const validatorCopyToEmail = (rule, value, callback) => {
      if (!value) {
        callback();
      }
      if (!/^[\.a-zA-Z0-9_-]+@[\.a-zA-Z0-9_-]+(\.[\.a-zA-Z0-9_-]+)+$/.test(value.trim())) {
        callback(new Error('邮箱格式不正确!'));
      } else if (this.copyToEmailList.includes(value.trim())) {
        callback(new Error('不能重复添加!'));
      } else {
        callback();
      }
    };
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      formLayout: 'horizontal',
      // form: this.$form.createForm(this),
      keyword: '',
      userChosen: [],
      userList: [],

      data,
      columns,
      isEdit: false,
      companyNow: {
        companyName: '',
        dealLeader: {},
        dealMembers: []
      },
      editName: '',
      editPhone: '',
      editEmail: '',
      current: 1,
      pageSize: 10,
      total: 20,
      form: {
        urge: '',
        editName: '',
        editPhone: '',
        editEmail: ''
      },
      rules: {
        urge: [{ required: true, message: '请选择文件接收人!' }],
        editName: [{ required: true, message: '请输入对接人姓名!' }],
        editPhone: [{ required: true, validator: validatorPhone, trigger: 'blur' }],
        editEmail: [{ required: true, validator: validatorEmail, trigger: 'blur' }],
        copyToEmail: [{ validator: validatorCopyToEmail, trigger: 'blur' }]
      },
      copyToEmailList: []
    };
  },
  created() {
    this.getMember();
  },
  methods: {
    addCopyToEmail() {
      let email = this.form.copyToEmail;
      if (email) {
        this.$refs.ruleForm.validateField('copyToEmail', valid => {
          console.log('valid');
          if (!valid) {
            this.copyToEmailList.push(this.form.copyToEmail.trim());
            this.form.copyToEmail = '';
            return true;
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
    deleteCopyToEmail(index) {
      this.copyToEmailList.splice(index, 1);
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.editMember();
          return true;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    onCancel() {
      this.isEdit = false;
      this.resetForm();
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.form = {
        urge: '',
        editName: '',
        editPhone: '',
        editEmail: ''
      };
      this.userList = [];
      this.copyToEmailList = [];
    },
    async onSearch() {
      // alert('search');
      try {
        let res = await getPortfolioMember({
          page: 1,
          pageSize: 100,
          searchName: this.keyword
        });
        console.log('getMember', res);
        if (res.code === 200) {
          this.data = res.data.list;
          this.total = res.data.total;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async onChange(page, pageSize) {
      try {
        let res = await getPortfolioMember({
          page: page,
          pageSize: pageSize
        });
        console.log('getMember', res);
        if (res.code === 200) {
          this.data = res.data.list;
          this.total = res.data.total;
        }
      } catch (err) {
        console.log(err);
      }
    },
    showModal(text) {
      this.isEdit = true;
      this.companyNow = text;
      this.form.editName = this.companyNow.name;
      this.form.editPhone = this.companyNow.phone;
      this.form.editEmail = this.companyNow.email;
      this.form.urge = this.companyNow.urgePeople.length > 0 ? this.companyNow.urgePeople.map(_ => _.id).join(',') : '';
      this.userList.push(...this.companyNow.urgePeople);
      this.copyToEmailList = this.companyNow.copyToEmails ? this.companyNow.copyToEmails.split(',') : [];
    },
    handleOk(e) {
      console.log(e);
      this.isEdit = false;
    },
    choseUserIds(members, parentIndex) {
      this.userList = members;
      this.form.urge = this.userList.map(_ => _.id).join(',');
    },

    delUserIds(user, parentIndex) {
      this.userList = this.userList.filter(_user => _user.id !== user.id);
      this.form.urge = this.userList.length > 0 ? this.userList.map(_ => _.id).join(',') : '';
    },
    // 编辑项目人员关系 editPortfolioMember
    async editMember() {
      try {
        let res = await editPortfolioMember({
          companyId: this.companyNow.companyId,
          urgeIds: this.userList.map(_ => _.id).join(','),
          name: this.form.editName,
          email: this.form.editEmail.trim(),
          phone: this.form.editPhone,
          copyToEmails: this.copyToEmailList.length > 0 ? this.copyToEmailList.join(',') : ''
        });
        console.log('taskQuery', res);
        if (res.code === 200) {
          this.$message.success('编辑成功');
          // console.log('this.tableData ', this.tableData);
          this.isEdit = false;
          this.resetForm();
          this.getMember();
        } else {
          this.$message.error('编辑失败');
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 获取项目人员关系 getPortfolioMember
    async getMember() {
      try {
        let res = await getPortfolioMember({
          page: 1,
          pageSize: 10
        });
        console.log('getMember', res);
        if (res.code === 200) {
          this.data = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error('获取人员信息失败');
        }
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.file-path-track {
  display: flex;
  li {
    font-size: 14px;
    span {
      cursor: pointer;
    }
  }
}
.table-layer {
  padding: 30px 50px;
  display: border-box;
}
.search-bar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 24px;
  margin-top: -24px;
}
.edit-alert {
  padding: 10px 30px;
  .edit-alert-item-info {
    display: inline-block;
    width: 100px;
    margin-right: 10px;
    color: rgba(0, 0, 0, 0.5);
  }
  .edit-alert-item-input {
    display: flex;
    // margin: 15px 0;
    align-items: center;
    line-height: 40px;
    height: 40px;
  }
  .edit-alert-dm {
    margin-right: 10px;
  }
  input {
    width: 240px;
    // height: 28px;
    // font-size: 12px;
  }
  .copy-to-email {
    margin-bottom: 16px;
  }
}
.pagination-buttom {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}
/deep/.ant-form-explain {
  font-size: 13px;
}
</style>
